import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { LetterRequestCustomer_Schedule_Interface } from 'src/app/Interface/LetterRequestCustomer_Schedule_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LetterRequestCustomerScheduleServiceService {

  constructor(private http: HttpClient) { }

  GetData(): Observable<Array<LetterRequestCustomer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterRequestCustomerSchedule").pipe(
      map(data => {
        return data as Array<LetterRequestCustomer_List_Interface>
      })
    )
  }

  GetModir(): Observable<Array<LetterRequestCustomer_Schedule_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterRequestCustomerSchedule/GetModir").pipe(
      map(data => {
        return data as Array<LetterRequestCustomer_Schedule_Interface>
      })
    )
  }

  GetModirSignle(id:number): Observable<LetterRequestCustomer_Schedule_Interface> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterRequestCustomerSchedule/GetModirSignle?id="+id).pipe(
      map(data => {
        return data as LetterRequestCustomer_Schedule_Interface
      })
    )
  }

}
